import React from 'react';
import { Gift, CheckCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CHECKOUT_URL = 'https://colorpack.store/cart/45914855866566:1';
export function OfferSection() {
  const bonuses = [{
    num: 1,
    title: 'Diario de Amor Propio de 30 Días',
    desc: 'Reconstruye tu autoestima día a día mediante ejercicios prácticos y reflexiones guiadas.',
    val: 19,
    img: 'https://cdn.magicpatterns.com/uploads/fy3TTJAbefimCDf6JXeUUC/BONO1.png'
  }, {
    num: 2,
    title: '50 Afirmaciones para Recordar tu Valor',
    desc: 'Afirmaciones poderosas para fortalecer tu autoestima y transformar tu diálogo interno.',
    val: 17,
    img: 'https://cdn.magicpatterns.com/uploads/hYYkXV7F8q9nu6xwDEcgPa/BONO2.png'
  }, {
    num: 3,
    title: 'Guía: Cómo Identificar Migajas Emocionales',
    desc: 'Aprende a reconocer las señales de relaciones que no te están dando lo que mereces.',
    val: 27,
    img: 'https://cdn.magicpatterns.com/uploads/wxKkhcbs7B5TjXWiqj7HDK/BONO3.png'
  }, {
    num: 4,
    title: 'Workbook Conviértete en Tu Prioridad',
    desc: 'Ejercicios prácticos para poner límites, fortalecer tu amor propio y recuperar tu confianza.',
    val: 29,
    img: 'https://cdn.magicpatterns.com/uploads/5d3Njt54jdtEWAYLDfrbKV/BONO4.png'
  }, {
    num: 5,
    title: 'Reto Nunca Más Migajas de 21 Días',
    desc: 'Un proceso guiado para ayudarte a romper patrones emocionales y recuperar tu poder personal.',
    val: 37,
    img: 'https://cdn.magicpatterns.com/uploads/rCvyzDeAiw5QKwdQX9zmvD/BONO5.png'
  }];
  return <section id="comprar" className="w-full bg-brand-cream py-16 md:py-24 px-4 scroll-mt-10" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        {/* Offer Intro */}
        <div className="text-center mb-16" data-id="element-84">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-85">
            Hoy no solo recibirás el Ebook MERECES MÁS
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-medium mb-8" data-id="element-86">
            También recibirás{' '}
            <span className="font-black text-brand-wine text-2xl md:text-3xl uppercase" data-id="element-87">
              GRATIS
            </span>{' '}
            estos 5 bonos exclusivos:
          </p>

          <div className="inline-flex items-center justify-center gap-2 bg-red-600 text-white font-bold px-6 py-3 rounded-full animate-pulse shadow-lg" data-id="element-88">
            <Gift className="w-6 h-6" data-id="element-89" />
            BONOS GRATIS SOLO POR HOY
          </div>
        </div>

        {/* Bonuses List - each with its own mockup */}
        <div className="space-y-8 mb-20" data-id="element-90">
          {bonuses.map(b => <a key={b.num} href={CHECKOUT_URL} className="block bg-white rounded-2xl p-6 md:p-8 shadow-lg border-l-8 border-brand-wine hover:shadow-2xl hover:-translate-y-1 transition-all duration-300" data-id="element-91">
              <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center" data-id="element-92">
                {/* Bonus Image */}
                <div className="w-full md:w-56 flex-shrink-0" data-id="element-93">
                  <img src={b.img} alt={b.title} className="w-full h-auto rounded-lg shadow-md" data-id="element-94" />
                </div>

                {/* Content */}
                <div className="flex-1 text-center md:text-left" data-id="element-95">
                  <span className="inline-block bg-brand-wine text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-96">
                    BONO #{b.num} · GRATIS HOY
                  </span>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3" data-id="element-97">
                    🎁 {b.title}
                  </h3>
                  <p className="text-gray-600 text-lg mb-4" data-id="element-98">{b.desc}</p>

                  <div className="inline-flex items-center gap-3 bg-gray-50 px-5 py-2 rounded-lg" data-id="element-99">
                    <span className="text-sm text-gray-500 font-bold uppercase" data-id="element-100">
                      Valor:
                    </span>
                    <span className="text-xl font-black text-red-500 line-through" data-id="element-101">
                      ${b.val} USD
                    </span>
                    <span className="text-green-600 font-black text-sm uppercase" data-id="element-102">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>)}
        </div>

        {/* Offer Summary Box */}
        <div className="bg-white rounded-3xl shadow-2xl border-4 border-brand-yellow overflow-hidden" data-id="element-103">
          <div className="bg-brand-yellow py-4 text-center" data-id="element-104">
            <h3 className="font-black text-2xl md:text-3xl text-brand-wineDark uppercase tracking-wide" data-id="element-105">
              RESUMEN DE LA OFERTA
            </h3>
          </div>

          <div className="p-8 md:p-12" data-id="element-106">
            <h4 className="font-bold text-xl mb-6 text-gray-800" data-id="element-107">
              HOY RECIBES:
            </h4>

            <ul className="space-y-4 mb-10" data-id="element-108">
              {['Ebook MERECES MÁS', 'Diario de Amor Propio de 30 Días', '50 Afirmaciones para Recordar tu Valor', 'Guía Cómo Identificar Migajas Emocionales', 'Workbook Conviértete en Tu Prioridad', 'Reto Nunca Más Migajas de 21 Días'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-109">
                  <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-110" />
                  <span className="text-lg md:text-xl font-bold text-gray-700" data-id="element-111">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="border-t-2 border-dashed border-gray-200 pt-8 text-center" data-id="element-112">
              <p className="text-2xl font-bold text-gray-600 mb-6" data-id="element-113">
                Valor Total: <span className="line-through" data-id="element-114">$158 USD</span>
              </p>

              <div className="space-y-2 mb-8 text-lg font-bold text-red-500/70" data-id="element-115">
                <p data-id="element-116">❌ No pagarás $158</p>
                <p data-id="element-117">❌ No pagarás $97</p>
                <p data-id="element-118">❌ No pagarás $47</p>
              </div>

              <p className="text-xl font-bold text-gray-800 mb-4 uppercase tracking-wider" data-id="element-119">
                Hoy puedes acceder por solo:
              </p>

              <div className="font-serif text-7xl md:text-8xl font-black text-brand-wine mb-10 drop-shadow-sm" data-id="element-120">
                $10.99{' '}
                <span className="text-3xl md:text-4xl text-brand-wine/70" data-id="element-121">
                  USD
                </span>
              </div>

              <CTAButton text="QUIERO ACCEDER AHORA — $10.99" microtext="↓ HAZ CLIC AQUÍ ABAJO ↓" className="!my-0" data-id="element-122" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}